import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import signalRecommenderI18nKeys from "../../utils/i18n";

type UploadDealSignalsButtonProps = {
    readonly isDisabled: boolean;
    readonly disabledTooltip?: string;
    readonly onClick: VoidFunction;
};

export const UploadDealSignalsButton = ({ isDisabled, disabledTooltip, onClick }: UploadDealSignalsButtonProps) => {
    const { translate } = useTranslate();

    const button = (
        <IconButton
            type="primary"
            iconName="upload-file"
            isDisabled={isDisabled}
            onClick={onClick}
            dataAutomation="signal-recommender-upload-csv"
        >
            {translate(signalRecommenderI18nKeys.button.uploadCsv)}
        </IconButton>
    );

    if (!isDisabled || !disabledTooltip) {
        return button;
    }

    // A disabled button emits no pointer events of its own, so the wrapper is what receives the hover.
    return (
        <Tooltip
            content={disabledTooltip}
            placement="top"
            data-automation="signal-recommender-upload-csv-tooltip"
        >
            <Flex inline>{button}</Flex>
        </Tooltip>
    );
};
